/*
 * @Author: your name
 * @Date: 2021-07-09 11:35:18
 * @LastEditTime: 2023-09-06 11:17:51
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\static\data\fontSize.js
 */

function toolsList() {
  return [
    { title: "文本", i18nTitle: "PE.Text", type: "4", image: "program_text.png", attr: "AttrText", tool: "ToolText" },
    { title: "数字时钟", i18nTitle: "PE.Digital", type: "6", image: "program_numclock.png", attr: "AttrNClock", tool: "ToolNClock" },
    { title: "模拟时钟", i18nTitle: "PE.Analog", type: "7", image: "program_imitateclock.png", attr: "AttrIClock", tool: "ToolIClock" },
    { title: "天气", i18nTitle: "PE.Weather", type: "5", image: "program_weather.png", attr: "AttrWeather", tool: "ToolWeather" },
    { title: "正计时", i18nTitle: "PE.Timing", type: "13", image: "program_positivetime.png", attr: "AttrTimewait", tool: "ToolTimewait" },
    { title: "倒计时", i18nTitle: "PE.Countdown", type: "12", image: "program_countdown.png", attr: "AttrCountdown", tool: "ToolCountdown" },
    { title: "流媒体", i18nTitle: "PE.StreamMedia", type: "14", image: "program_media.png", attr: "AttrMedia", tool: "ToolMedia" },
    // { title: "RSS", i18nTitle: "PE.RSS", type: "17", image: "program_Rss.png", attr: "AttrRss", tool: "ToolRss" },
    { title: "图片", i18nTitle: "PE.Picture", type: "2", image: "", attr: "AttrImage", tool: "ToolImage" },
    { title: "视频", i18nTitle: "PE.Video", type: "1", image: "", attr: "AttrVideo", tool: "ToolVideo" },
    { title: "网页", i18nTitle: "PE.Webpage", type: "18", image: "program_webset.png", attr: "AttrWebpage", tool: "ToolWebpage" },
    // { title: "日历", type: "11", image: "program_calendar.png", attr: "AttrCalendar", tool: "ToolCalendar"  },
  ];
}

export default toolsList;

// case "5": return "ToolWeather";
// // case "11": return "ToolCalendar";
// case "12": return "ToolCountdown";
// case "7": return "ToolIClock";
// case "2": return "ToolImage";
// case "14": return "ToolMedia";
// case "6": return "ToolNClock";
// case "17": return "ToolRss";
// case "4": return "ToolText";
// case "13": return "ToolTimewait";
// case "1": return "ToolVideo";

// case "5": return "AttrWeather";
// // case "11": return "AttrCalendar";
// case "12": return "AttrCountdown";
// case "7": return "AttrIClock";
// case "2": return "AttrImage";
// case "14": return "AttrMedia";
// case "6": return "AttrNClock";
// case "17": return "AttrRss";
// case "4": return "AttrText";
// case "13": return "AttrTimewait";
// case "1": return "AttrVideo";
// default: return "";